{
  "id": 22,
  "location": "paris",
  "difficulty": "normal",
  "moves": 27,
  "kinds": 6,
  "goals": [
    { "type": "collect", "kind": "donut", "count": 40 }
  ],
  "stars": [4360, 5360],
  "board": [
    "# # . . . . # #",
    "# . . . . . . #",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    "# . . . . . . #",
    "# # . . . . # #"
  ],
  "calibration": { "runs": 1000, "winRate": 0.75, "movesLeft": 5.7, "closeLosses": 0.083, "target": 0.73 }
}
